// extracted by mini-css-extract-plugin
export default {"disableCloseButton":"ZC18wyR8ErZAjOs1UG9Q","blockBackdropClick":"edyCHn9VHZha8s_oiEev"};